import { useContext, useEffect, useState } from 'react';
import { AppContext, AppContextProvider } from './contexts/AppContext';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import MobileComponent from './components/MobilePlaceholder';
import ChatsPage from './pages/ChatsPage';

const LoadingPage = () => {
  return <>Loading...</>
}

const AuthenticatedRoute = ({ ...props }) => {
  const appContext = useContext(AppContext);
  const location = useLocation();

  return (
    appContext.user === undefined || appContext.showLoadingPage
      ? <LoadingPage />
      : (
        appContext.user
          ? props.elem
          : <Navigate to="/login" replace state={{ from: location }} />
      )
  )
}

const LoginRoute = ({ ...props }) => {
  const appContext = useContext(AppContext);
  const location = useLocation();

  return (
    appContext.user === undefined || appContext.showLoadingPage
      ? <LoadingPage />
      : (
        !appContext.user
          ? props.elem
          : <Navigate to={`/`} replace state={{ from: location }} />
      )
  )
}

function App() {

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile)
    return <MobileComponent />

  return (
    <AppContextProvider>
      <Routes>
        <Route path='/' element={<Navigate to={`/dashboard`} />} />

        <Route path='/login' element={<LoginRoute elem={<LoginPage />} />} />
        <Route path='/dashboard' element={<AuthenticatedRoute elem={<DashboardPage />} />} />
        <Route path='/chats' element={<AuthenticatedRoute elem={<ChatsPage />} />} />

        {/*Unknown 404 Paths*/}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </AppContextProvider>
  );
}

export default App;
